import { render, staticRenderFns } from "./AsEmployeeQuizProgressAlert.vue?vue&type=template&id=6f6213d2&scoped=true"
import script from "./AsEmployeeQuizProgressAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./AsEmployeeQuizProgressAlert.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsEmployeeQuizProgressAlert.vue?vue&type=style&index=0&id=6f6213d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6213d2",
  null
  
)

export default component.exports